<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>Only the Brightest Stars</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent">By Andrew Grey</p>
<p class="P_Normal"> </p>
<p class="P_Normal">The problem with being an actor on top of the world is that you have a long way to fall.</p>
<p class="P_Normal">Logan Steele is miserable. Hollywood life is dragging him down. Drugs, men, and booze are all too easy. Pulling himself out of his self-destructive spiral, not so much.</p>
<p class="P_Normal">Brit Stimple does whatever he can to pay the bills. Right now that means editing porn. But Brit knows he has the talent to make it big, and he gets his break one night when Logan sees him perform on stage.</p>
<p class="P_Normal">When Logan arranges for an opportunity for Brit to prove his talent, Brit’s whole life turns around. Brit’s talent shines brightly for all to see, and he brings joy and love to Logan’s life and stability to his out-of-control lifestyle. Unfortunately, not everyone is happy for Logan, and as Brit’s star rises, Logan’s demons marshal forces to try to tear the new lovers apart.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?8dc1e652